module.exports = __webpack_public_path__ + "img/signup-new-square-3.b4bd6809.png";